import createBaseService from "@/api/base-service.ts";
import type { CourtBranch } from "../../types/court-branches";

const courtBranchService = {
	...createBaseService<CourtBranch>("/court-branches"),
};

export default courtBranchService;
